// Imports
  // React
  import React, { useContext } from 'react'
  // Context
  import { CartContext } from '../context/CartContext'
  // Firebase
  import { updateItemCode, updateItemPrice } from "../firebase/FirebaseClient";
  // Components
  import ItemCardEdition from './ItemCardEdition'




// rafce

const ItemCard = ({ item }) => {

  // Functions
  const { getItem } = useContext(CartContext);

  let itemInCart = getItem(item.name);


  // Component
  return (
    <>
      <div className='product-card-image'>
        <span style={{cursor:"pointer"}} onClick={() => updateItemCode(item.id, item.code)}>{item.code}</span>
        <img src={item.picture} alt="Foto del Producto" />
      </div>
      <div className='item-card-info'>
        <div className='item-card-description'>
          <h2>{item.name}</h2>
          <p>{item.description}</p>
          <span style={{cursor:"pointer"}} onClick={() => updateItemPrice(item.id, item.price)} >$ {item.price.toFixed(2)}</span>
        </div>
        <ItemCardEdition item={item} /> 
      </div>
    </>
  )
}

export default ItemCard

